import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useDeleteKey = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutateDeleteFn(ENDPOINTS.DELETE_KEY, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
